<template>
  <div
    v-expose-track="{
      userChangePrice: {
        mapId: 'changePriceGood',
        data: {
          spm: $trackMap.userChangePrice.goodExpose,
          ...tracerParams()
        }
      }
    }"
    class="good-item"
    :style="{ opacity: opacity }"
    @click="goDetail"
  >
    <div v-if="canChangePrice" class="select-operate" @click.stop="select">
      <IconFont
        :name="isSelect ? 'xuankuang-gouxuan' : 'xuankuang-weixuanzhong'"
        :color="isSelect ? '#15bb5c' : '#979797'"
        size="20px"
      ></IconFont>
    </div>

    <good-image
      :img-url="sku.skuImg.imgUrl"
      :image-width="goodWidth"
      :stock-status="stockStatus"
      :sku-img="skuImg"
      :custom-style="customStyle"
    />
    <div class="info">
      <div class="sku-header">
        {{ sku.skuBase.skuName }} {{ sku.skuFormats.skuFormat }}
      </div>
      <div class="good-price">
        <div v-if="!!ssuInfo.ssuPrice.priceShield" class="no-login">
          {{ ssuInfo.ssuPrice.priceShieldText }}
        </div>
        <template v-else>
          <div class="price-wrapper">
            <span class="prefix">改价后低至¥</span>
            <span class="value">{{ unitPrice }}</span>
            <span class="unit">/{{ ssuInfo.ssuPrice.priceUnit || '' }}</span>
            <span v-if="mcOriginPrice" class="orgiin-price">{{
              mcOriginPrice
            }}</span>
          </div>

          <new-operator
            v-if="showAdd"
            :use-simple="customOperator.simple"
            :use-arrived-notice-icon="customOperator.useArrivedNoticeIcon"
            show-simple-count
            :ssu="sku"
            class="operator"
            @add="addGoods"
            @subtract="subtractGoods"
            @goDetail="goDetail"
          />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import goodImage from '@/common/cms/modules/goods/template/widgets/good-image.vue'
import NewOperator from '@/common/widgets/newOperator/newIndex.vue'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
export default {
  components: {
    goodImage,
    NewOperator
  },
  props: {
    changeSsuid: {
      type: [Number, String],
      default: ''
    },

    canChangePrice: {
      type: Boolean,
      default: false
    },
    sku: {
      type: Object,
      default: () => ({})
    },
    joinSsuIds: {
      type: Array,
      default: () => []
    },
    skuIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      customOperator: {
        simple: false,
        showPromoteTip: true,
        type: 'normal'
      },
      customStyle: {
        name: {
          margin: 0
        },
        with: '1.08rem',
        height: '1.08rem',
        goodImage: {
          overflow: 'hidden',
          'border-radius': '.16rem',
          position: 'relative',
          'z-index': 2
        }
      },
      goodWidth: 80
    }
  },
  computed: {
    ssuInfo() {
      return this.sku?.ssuList[0]
    },
    ssuId() {
      return this.ssuInfo?.ssuId || 0
    },
    skuImg() {
      return this?.sku?.skuImg
    },
    // 关于sku和ssu的规格信息
    formatInfo() {
      return this.sku?.skuFormats?.skuFormat || ''
    },

    stockStatus() {
      return this?.sku?.skuImg?.expectArrivedRemind || ''
    },
    unitPrice() {
      return this.ssuInfo.ssuPrice?.unitPrice || ''
    },
    priceUnit() {
      return this.ssuInfo.ssuPrice?.priceUnit | ''
    },
    mcOriginPrice() {
      return this.ssuInfo.ssuPrice?.mcOriginPrice || ''
    },
    originalUnitPrice() {
      return this.ssuInfo.ssuPrice?.originalUnitPrice || ''
    },
    isSelect() {
      // eslint-disable-next-line eqeqeq
      return this.changeSsuid == this.ssuId
    },
    opacity() {
      let opacity = 1
      if (this.joinSsuIds.length) {
        const index = this.joinSsuIds.findIndex(item => {
          // eslint-disable-next-line eqeqeq
          return item == this.ssuId
        })
        // eslint-disable-next-line eqeqeq
        if (index == -1) {
          opacity = 0.5
        }
      }

      return opacity
    },
    showAdd() {
      const index = this.joinSsuIds.findIndex(item => {
        // eslint-disable-next-line eqeqeq
        return item == this.ssuId
      })
      // eslint-disable-next-line eqeqeq
      return index != -1
    }
  },
  methods: {
    select() {
      const spm = this.$trackMap.userChangePrice.ssuSelect
      this.tracerReport(spm)
      const tracerParams = this.tracerParams()
      this.$emit('changeSsu', this.ssuId, tracerParams)
    },
    tracerParams() {
      return {
        ssu_id: Number(this.ssuId),
        changed_price: this.unitPrice,
        origin_price: this.originalUnitPrice
      }
    },
    // 统一商品模块埋点上报方法
    tracerReport(spm) {
      const tracerParams = this.tracerParams()
      this.$track(spm, tracerParams)
    },
    // 商品加购处理
    addGoods() {
      const spm = this.$trackMap.userChangePrice.goodAdd
      this.tracerReport(spm)
    },
    // 商品减购处理
    subtractGoods() {},
    goDetail() {
      const spm = this.$trackMap.userChangePrice.goDetail
      const tickReferId = `${spm}.${this.skuIndex}`

      this.tracerReport(spm)
      this.$nativeRedirect(nativeRoutes.goodsDetail, {
        id: this.ssuId,
        tickReferId
      })
    }
  }
}
</script>

<style lang="scss">
.good-item {
  position: relative;

  width: 100%;

  padding: 10px 8px 10px 12px;

  box-sizing: border-box;
  @include flex(row, normal, center, nowrap);
  .select-operate {
    margin-right: 12px;
  }
}
.info {
  position: relative;

  width: 0;
  height: 80px;

  margin-left: 0.16rem;
  // overflow: hidden;

  flex: auto;
  @include flex(column, space-between);

  .sku-header {
    @include text(0.3rem, #262626, bold);
    @include text-overflow-ellipsis-single;
  }
  .good-price {
    display: flex;

    position: relative;

    align-items: baseline;
    .no-login {
      margin-top: 0.1rem;

      font-size: 0.32rem;
      font-weight: 500;
      color: #f03100;
    }

    .price-wrapper {
      display: inline-block;

      margin-top: 0.08rem;

      font-weight: bold;
      white-space: nowrap;
      color: #f03100;

      .prefix {
        font-size: 0.2rem;
      }
      .value {
        font-size: 0.44rem;
      }
      .unit {
        font-size: 13px;
      }
      .orgiin-price {
        text-decoration: line-through;
        @include text(0.2rem /* 10/50 */, #bfbfbf);
      }
    }
  }

  .operator {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>
